import React from 'react';

import { BaseModal } from '../BaseModal';

interface ConfirmProductionChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  featureName: string;
  entityName: string;
  turnOn: boolean;
  isSaving: boolean;
}

export const ConfirmProductionChangeModal: React.FC<
  ConfirmProductionChangeModalProps
> = ({
  isOpen,
  onClose,
  onConfirm,
  featureName,
  entityName,
  turnOn,
  isSaving,
}) => {
  const actionText = turnOn ? 'TURN ON' : 'TURN OFF';

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={`Turn ${turnOn ? 'on' : 'off'} ${featureName}?`}
      isDismissable={!isSaving}
      hideCloseButton
      footerContent={{
        onCancel: onClose,
        onConfirm,
        isLoading: isSaving,
        isDisabled: isSaving,
        isDestructive: !turnOn,
        confirmText: isSaving ? 'SAVING...' : actionText,
        cancelText: 'CANCEL',
      }}
    >
      <p className="text-default-500 text-sm">
        This changes live behaviour for{' '}
        <span className="font-medium text-foreground">{entityName}</span> right
        away.
      </p>
    </BaseModal>
  );
};
